import { useQuery } from '@tanstack/react-query';
import api from '../Services/api';
import globals from '../Globals.json';

interface NcmOption {
  value: string;
  label: string;
  ncm_code: string;
}

export const useQueryNcmByCodeOrDes = (searchTerm: any) => {
  return useQuery<NcmOption[], Error>({
    queryKey: ['ncms'],
    queryFn: async () => {
      let url = `${globals.api.taxes}/ncms?limit=250`;

      if (searchTerm.length >= 3) {
        const isNumber = !isNaN(Number(searchTerm));
        url = isNumber
          ? `${globals.api.taxes}/ncms?codigo=${searchTerm}`
          : `${globals.api.taxes}/ncms?descricao=${searchTerm}`;
      }

      const { data } = await api.get(url);
      const ncmList: NcmOption[] = data.data
        .map((item: any) => ({
          value: item.id,
          label: `${item.codigo} - ${item.descricao}`,
          ncm_code: item.codigo,
        }))
        .slice(0, 400);

      return ncmList;
    },
    enabled: !!searchTerm || searchTerm === '',
    refetchInterval: false, // formulário/dado de referência: sem atualização automática
  });
};
